import { showNotification } from '@mantine/notifications';
import { useCallback, useContext } from 'react';

import { UserContext } from '~/components/providers/UserProvider';

export function useEntrantsReferralLink(contestId: string, contestType: string) {
  const { user } = useContext(UserContext);
  const userId = user?.id;

  const createReferralLink = useCallback((eoURL?: string) => {
    const contestURL = new URL(eoURL || `${window.location.origin}/contest/${contestId}/detail`)
    contestURL.searchParams.set('utm_source', 'Referral');
    contestURL.searchParams.set('utm_campaign', contestType);
    contestURL.searchParams.set('utm_medium', 'Contest_Page_Invite');
    contestURL.searchParams.set('referral', userId);

    const referralLink = contestURL.toString();

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(referralLink)
        .then(() => {
          showNotification({
            title: 'Success',
            message: 'Link copied to clipboard!',
            color: 'green',
            autoClose: 3000,
          });
        })
        .catch(() => {
          showNotification({
            title: 'Error',
            message: 'Failed to copy link to clipboard',
            color: 'red',
            autoClose: 3000,
          });
        });
    }
  }, [contestId, contestType, userId]);

  return { createReferralLink };
}

